import Button from "@material-ui/core/Button";
import { Fragment } from "react";
import { PuffLoader } from "react-spinners";
import PulseLoader from "react-spinners/PulseLoader";

// ------ all used props in this module ------
// OnLoadMode => ture | false
// DisableMode => ture | false
// ClassNames => ture (should be an array) | false
// DisableOnLoadMode => ture | false
// Text => string
// DoAction => giving a function
// WhiteMode => true | false
// Type => submit | reset | button

const ButtonWithLoader = (props) => {
  const {
    ClassNames,
    OnLoadMode,
    DisableMode,
    WhiteMode,
    DisableOnLoadMode,
    Text,
    Type,
    haveCertificate = false,
  } = props;

  return (
    <div
      className={`SAMSUNG_ACTION_BUTTON${WhiteMode ? " White" : ""}${
        ClassNames ? " " + ClassNames.join(" ") : ""
      }`}
    >
      <Button
        type={Type && Type}
        disabled={
          DisableOnLoadMode ? (OnLoadMode ? true : false) : DisableMode || false
        }
        className={"Transition_All_5ms"}
        onClick={(e) =>
          (DisableOnLoadMode
            ? OnLoadMode
              ? false
              : true
            : DisableMode
            ? false
            : true) && props.DoAction(e)
        }
      >
        <span
          className={`SAMSUNG_MAIN_BUTTON_TEXT Transition_All_5ms${
            OnLoadMode ? " LoaderIsActive" : ""
          }`}
        >
          {Text || "تایید"}
        </span>
        <span
          className={`SAMSUNG_MAIN_BUTTON_LOADER Transition_All_5ms${
            OnLoadMode ? " LoaderIsActive" : ""
          }`}
        >
          {OnLoadMode ? (
            <PulseLoader color="#1e1e1e" size={10} />
          ) : (
            // <PuffLoader size={30} color={'#fff'} />
            <Fragment />
          )}
        </span>
      </Button>
      {haveCertificate ? (
        <div className="haveCertificate">
          شما قبلا برای این آزمون گواهینامه دریافت کرده اید.
        </div>
      ) : null}
    </div>
  );
};

export default ButtonWithLoader;
